import React from 'react'
import styled from 'styled-components'
import Link from '../../../utils/Link'
import utmLinkGenerator from '../../../utils/UTMLinkGenerator'

const VyberTheme = ({ article, index, utmParams, imageSize, handleGaEvent }) => {
  const {
    guid,
    title,
    link,
    images: {
      [imageSize]: imageSrc
    }
  } = article

  const positionInWidget = index + 2

  const onClick = (event) => {
    handleGaEvent(event, {
      id: guid,
      position: positionInWidget,
      url: link,
      title
    })
  }

  const linkWithUtm = utmLinkGenerator.createLink(link, { ...utmParams, utmTerm: `position-${positionInWidget}` })

  return (
    <StyledLink href={linkWithUtm} onClick={onClick}>
      <StyledWrapper backgroundUrl={imageSrc}>
        <StyledTitle>{title}</StyledTitle>
      </StyledWrapper>
    </StyledLink>
  )
}

const StyledWrapper = styled.div`
  background-image: url(${({ backgroundUrl }) => backgroundUrl});
  background-size: cover;
  background-repeat: no-repeat;
  width: 130px;
  height: 90px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 16px;
  text-align: center;
  border-radius: 4px;

  &:after {
    content: '';
    background: linear-gradient(
      180deg,
      rgba(18, 28, 49, 0.6) 0%,
      rgba(38, 58, 99, 0) 100%
    );
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }
`

const StyledLink = styled(Link)`
  &:hover {
    text-decoration-color: #fff;
  }
`

const StyledTitle = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: ${props => props.theme.vyber.color};
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.25);
  z-index: 1;
`

export default VyberTheme
